$secondary-green: #7fb02f;

.wrap {
	width: 100%;
	padding: 0 0.7rem 0 0.7rem;
	display: flex;
	flex-direction: column;
	padding-bottom: 1em;
}

.toolbar {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	margin-bottom: 0.5rem;
	flex-wrap: wrap;
}
.toolbarLeft {
	display: inline-flex;
	align-items: center;
	gap: 0.5rem;
}
.toolbarRight {
	margin-left: auto;
	display: inline-flex;
	align-items: center;
	gap: 0.5rem;
}
.toolbarPager {
	display: inline-flex;
	align-items: center;
	gap: 0.25rem;
	margin-left: 0.5rem;
}
.toolbarActions {
	display: inline-flex;
	align-items: center;
	gap: 0.375rem;
	padding-left: 0.625rem;
	margin-left: 0.25rem;
	border-left: 1px solid #e5e7eb;
}
.toolbarActionsDropdown {
	position: relative;
}
.toolbarActionsMenu {
	position: absolute;
	top: calc(100% + 0.25rem);
	right: 0;
	min-width: 14rem;
	background: #fff;
	border: 1px solid #e5e7eb;
	border-radius: 0.5rem;
	box-shadow:
		0 10px 15px -5px rgba(0, 0, 0, 0.08),
		0 5px 8px -4px rgba(0, 0, 0, 0.06);
	z-index: 20;
	list-style: none;
	padding: 0.375rem;
	margin: 0;
}
.toolbarActionsMenuItem {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	width: 100%;
	padding: 0.4rem 0.625rem;
	border: none;
	background: none;
	border-radius: 0.375rem;
	font-size: 0.875rem;
	color: #111827;
	cursor: pointer;
	text-align: left;

	&:hover {
		background: #f3f4f6;
	}
}
.rangeText {
	font-size: 0.875rem;
	color: #6b7280;
}

.smallText {
	font-size: 0.875rem;
	color: #6b7280;
}

.select {
	border: 1px solid #e5e7eb;
	background: #fff;
	border-radius: 0.5rem;
	padding: 0.35rem 0.5rem;
	font-size: 0.9rem;
}

.dropdown {
	position: relative;
	display: none;
}
.menu {
	position: absolute;
	top: calc(100% + 0.25rem);
	right: 0;
	min-width: 16rem;
	max-height: 18rem;
	overflow: auto;
	background: #fff;
	border: 1px solid #e5e7eb;
	border-radius: 0.5rem;
	box-shadow:
		0 10px 15px -5px rgba(0, 0, 0, 0.08),
		0 5px 8px -4px rgba(0, 0, 0, 0.06);
	z-index: 20;

	&::-webkit-scrollbar {
		width: 5px;
		height: 5px;
	}

	&::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #a8a8a8;
		border-radius: 15px;
	}
}
.menuHeader {
	padding: 0.5rem 0.75rem;
	border-bottom: 1px solid #f3f4f6;
	font-weight: 600;
	font-size: 0.9rem;
	color: #111827;
}
.menuList {
	list-style: none;
	padding: 0.5rem;
	margin: 0;
}
.menuItem {
	padding: 0.25rem 0.25rem;
}
.checkbox {
	display: inline-flex;
	align-items: center;
	gap: 0.5rem;
	font-size: 0.9rem;
	color: #111827;
	input {
		width: 16px;
		height: 16px;
		accent-color: $secondary-green;
	}
}

.tableWrap {
	display: flex;
	flex-direction: column;
	overflow: hidden;
	border: 1px solid #e5e7eb;
	border-radius: 0.75rem;
	background: #fff;
}

.headerContainer {
	overflow: hidden;
}

.table {
	width: 100%;
	border-collapse: collapse;
	border-spacing: 0;
	font-size: 0.92rem;
	table-layout: fixed;
}

.thead {
	background: #f9fafb;
	border-bottom: 1px solid #e5e7eb;
}

.th {
	text-align: left;
	padding: 0.6rem 0.75rem;
	border-bottom: 1px solid #e5e7eb;
	color: #111827;
	font-weight: 600;
	font-size: 0.9rem;
	user-select: none;
	vertical-align: top;
	white-space: normal;
	overflow: visible;
	border-right: 1px solid #e5e7eb;
}
.thCompact {
	padding: 0.4rem 0.5rem;
	font-size: 0.75rem;
	line-height: 1.2;
	white-space: normal;
	word-break: break-word;
}
.thCentered {
	.thInner {
		justify-content: center;
	}
}
.thSortable {
	cursor: pointer;
}
.thInner {
	display: inline-flex;
	align-items: center;
	gap: 0.35rem;
}
.sortIcon {
	width: 16px;
	height: 16px;
	color: #6b7280;
}
.sortIdle {
	opacity: 0.5;
}

.bodyContainer {
	overflow-y: auto;
	overflow-x: hidden;
	scrollbar-gutter: stable;

	&::-webkit-scrollbar {
		width: 5px;
		height: 5px;
	}

	&::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #a8a8a8;
		border-radius: 15px;
	}
}

.tbody {
	background: #fff;
}

.tr {
	border-bottom: 1px solid #f3f4f6;
}
.tr:nth-child(even) {
	background: #f9fafb;
}
.tr:hover {
	background: #fafafa;
}
.trClickable {
	cursor: pointer;
}
// .trExpanded {
// 	background: rgba(127, 176, 47, 0.08) !important;
// }

.td {
	padding: 0.6rem 0.75rem;
	vertical-align: top;
	color: #111827;
	white-space: normal;
	overflow: visible;
	text-overflow: clip;
	word-break: break-word;
	overflow-wrap: anywhere;
	hyphens: auto;
	position: relative;
}
.tdCompact {
	padding: 0.4rem 0.5rem;
	font-size: 0.8rem;
	line-height: 1.3;
}

.cellInner {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.5rem;
	overflow: visible;
	text-overflow: clip;
	white-space: inherit;
}

.tdCenter {
	text-align: center;
	& .cellInner {
		justify-content: center;
	}
}

.tdRight {
	text-align: right;
	& .cellInner {
		justify-content: flex-end;
	}
}

.expandButton {
	background: none;
	border: none;
	padding: 0.25rem;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	color: #6b7280;
	transition: all 0.2s ease;
	border-radius: 0.25rem;
	flex-shrink: 0;

	&:hover {
		background: rgba(0, 0, 0, 0.05);
		color: #7fb02f;
	}

	&:active {
		transform: scale(0.95);
	}
}

.expandedRow {
	background: rgba(127, 176, 47, 0.04);
}

.expandedCell {
	border-bottom: 2px solid #7fb02f;
}

.clamp2 {
	white-space: normal;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
}

.wrap {
	white-space: normal;
	word-break: break-word;
}

.expander {
	display: flex;
	justify-content: center;
	align-items: center;
}

.subRow {
	background: #fcfcfc;
}
.subTd {
	padding: 0.75rem;
	border-top: 1px dashed #e5e7eb;
}

.empty {
	text-align: center;
	padding: 1.75rem 0.75rem;
	color: #6b7280;
}

@media (max-width: 640px) {
	.headerContainer {
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
	}
	.bodyContainer {
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
	}
	.toolbarLeft {
		display: none;
	}
	.toolbar {
		gap: 0.4rem;
		justify-content: space-between;
	}
	.toolbarRight {
		margin-left: 0;
		flex: 1;
		justify-content: flex-end;
	}
	.toolbarPager {
		margin-left: 0;
	}
}
